import {
  GET_SPONSORS_LOADING,
  GET_SPONSORS_SUCCESS,
  GET_SPONSORS_ERROR,
  CREATE_SPONSORS_LOADING,
  CREATE_SPONSORS_SUCCESS,
  CREATE_SPONSORS_ERROR,
  DELETE_SPONSORS_LOADING,
  DELETE_SPONSORS_SUCCESS,
  DELETE_SPONSORS_ERROR,
  EDIT_SPONSORS_LOADING,
  EDIT_SPONSORS_SUCCESS,
  EDIT_SPONSORS_ERROR,
} from "../../../constant/actionTypes";
import { apiDelete, apiGet, apiPut } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
export const getSponsors = () => (dispatch) => {
  dispatch({ type: GET_SPONSORS_LOADING });

  apiGet(
    ApiEndpoints.sponsor.base,
    (response) => {
      // console.log("get sponsors response ==============> ", response);
      if (response.error == true) {
        dispatch({ type: GET_SPONSORS_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_SPONSORS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_SPONSORS_ERROR, response: error });
    }
  );
};

export const createSponsor = (data, refresh, setRefresh) => (dispatch) => {
  dispatch({ type: CREATE_SPONSORS_LOADING });
  apiPut(
    ApiEndpoints.sponsor.base + ApiEndpoints.sponsor.add,
    data,
    (response) => {
      if (response.error == true) {
        dispatch({ type: CREATE_SPONSORS_ERROR, response: response.message });
      } else {
        dispatch({ type: CREATE_SPONSORS_SUCCESS, response: response });
        setRefresh(!refresh);
      }
    },
    (error) => {
      dispatch({ type: CREATE_SPONSORS_ERROR, response: error });
    }
  );
};

export const deleteSponsor = (id) => (dispatch) => {
  dispatch({ type: DELETE_SPONSORS_LOADING });
  apiDelete(
    `${ApiEndpoints.sponsor.base}${ApiEndpoints.sponsor.delete}${id}`,
    (response) => {
      // console.log("delete sponsor response ....", response);

      if (response.error == true) {
        dispatch({ type: DELETE_SPONSORS_ERROR, response: response.message });
      } else {
        dispatch({ type: DELETE_SPONSORS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: DELETE_SPONSORS_ERROR, response: error });
    }
  );
};

export const editSponsor = (id, data) => (dispatch) => {
  dispatch({ type: EDIT_SPONSORS_LOADING });
  apiPut(
    `${ApiEndpoints.sponsor.base}${ApiEndpoints.sponsor.update}${id}`,
    data,
    (response) => {
      // console.log("edit sponsor response ....", response);

      if (response.error == true) {
        dispatch({ type: EDIT_SPONSORS_ERROR, response: response.message });
      } else {
        dispatch({ type: EDIT_SPONSORS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: EDIT_SPONSORS_ERROR, response: error });
    }
  );
};
